/* Coutelier UI Refresh (Oct 2026)
   1. Hover-to-open header dropdowns. Keeps Dawn's click/keyboard behavior
      intact; only adds mouse intent on devices that actually have a hover pointer.
   2. Title separators. Product titles follow "Maker | Line | Shape 000mm".
      Wrap each " | " so CSS can render it as a slim silver bar.
   3. Footer social icons. Dawn renders them beside the newsletter form; move
      them under the first footer column so they read as part of the address. */
(function () {
  /* ---------- 1. Hover dropdowns ---------- */
  var CLOSE_DELAY = 140;

  function bindDropdown(details) {
    if (details.dataset.ctlHover) return;
    details.dataset.ctlHover = '1';
    var timer = null;

    details.addEventListener('mouseenter', function () {
      window.clearTimeout(timer);
      if (!details.open) details.open = true;
    });

    details.addEventListener('mouseleave', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        if (details.open) details.open = false;
      }, CLOSE_DELAY);
    });
  }

  function initDropdowns() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    document
      .querySelectorAll('.header__inline-menu header-menu > details')
      .forEach(bindDropdown);
  }

  /* ---------- 2. Title separators ---------- */
  var TITLE_SELECTOR = [
    '.product__title h1',
    '.product__title .h1',
    '.card__heading .full-unstyled-link',
    '.cart-item__name',
    '.cart-notification-product__name',
    '.quick-add-modal .product__title h2'
  ].join(',');

  function decorateTitle(el) {
    if (el.dataset.ctlSep) return;
    el.dataset.ctlSep = '1';

    Array.prototype.slice.call(el.childNodes).forEach(function (node) {
      if (node.nodeType !== 3 || node.nodeValue.indexOf(' | ') === -1) return;

      var parts = node.nodeValue.split(' | ');
      var frag = document.createDocumentFragment();

      parts.forEach(function (part, i) {
        if (i > 0) {
          var sep = document.createElement('span');
          sep.className = 'ctl-sep';
          sep.textContent = '|';
          frag.appendChild(document.createTextNode(' '));
          frag.appendChild(sep);
          frag.appendChild(document.createTextNode(' '));
        }
        frag.appendChild(document.createTextNode(part));
      });

      el.replaceChild(frag, node);
    });
  }

  function decorateTitles(root) {
    (root || document).querySelectorAll(TITLE_SELECTOR).forEach(decorateTitle);
  }

  /* ---------- 3. Footer social icons ---------- */
  function placeFooterSocial() {
    var footer = document.querySelector('.footer');
    if (!footer) return;
    var social = footer.querySelector('.footer-block--newsletter .footer__list-social');
    var firstBlock = footer.querySelector('.footer__blocks-wrapper .footer-block');
    if (!social || !firstBlock) return;
    social.classList.add('ctl-footer-social');
    firstBlock.appendChild(social);
  }

  /* ---------- Boot ---------- */
  function init() {
    initDropdowns();
    decorateTitles(document);
    placeFooterSocial();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor re-renders sections; rebind when it does. */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('.header__inline-menu')) initDropdowns();
    decorateTitles(e.target || document);
    placeFooterSocial();
  });

  /* Cart drawer and recommendations swap markup in via fetch. Watch for new
     nodes and decorate only those, so apps that churn the DOM cost nothing. */
  var queue = [];
  var pending = null;
  var observer = new MutationObserver(function (records) {
    records.forEach(function (r) {
      for (var i = 0; i < r.addedNodes.length; i++) {
        if (r.addedNodes[i].nodeType === 1) queue.push(r.addedNodes[i]);
      }
    });
    if (!queue.length) return;
    window.clearTimeout(pending);
    pending = window.setTimeout(function () {
      var nodes = queue;
      queue = [];
      nodes.forEach(function (node) {
        if (!node.isConnected) return;
        if (node.matches && node.matches(TITLE_SELECTOR)) decorateTitle(node);
        decorateTitles(node);
      });
    }, 60);
  });

  function observe() {
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.body) observe();
  else document.addEventListener('DOMContentLoaded', observe);
})();